var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2683 21.0254L20.7945 12.4992C21.4796 11.8141 21.7916 10.8404 21.6324 9.88471L20.8167 4.9906C20.6762 4.14765 20.0156 3.4871 19.1727 3.34661L14.2786 2.53092C13.3229 2.37164 12.3491 2.6837 11.6641 3.36878L3.13789 11.8949C1.96632 13.0665 1.96632 14.966 3.13789 16.1376L8.0257 21.0254C9.19728 22.197 11.0968 22.197 12.2683 21.0254Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.de7afc884d5b3d5a7ac80a1ce675634e.svg";
export { ForwardRef as ReactComponent };